import { Component, HostBinding, input, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'lib-accordion',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './accordion.component.html',
  styleUrls: ['./accordion.component.scss'],
})
export class AccordionLibComponent {
  header = input();
  icon = input();
  subtitle = input();

  get iconPath(): string | null {
    return this.icon() ? `/assets/images/icons/${this.icon()}` : null;
  }

  private _open = false;

  @HostBinding('class.open')
  get isOpen() { return this._open; }

  toggle(): void { this._open = !this._open; }
}
